import { useState } from "react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { GoldenShowcase } from "@/components/GoldenShowcase";
import { VideoGallery } from "@/components/VideoGallery";
import { Reviews } from "@/components/Reviews";
import { CommunitySection } from "@/components/CommunitySection";
import { CareersSection } from "@/components/CareersSection";
import { DonationSection } from "@/components/DonationSection";
import { Footer } from "@/components/Footer";
import { WhatsappFab } from "@/components/WhatsappFab";
import { LeadCaptureModal } from "@/components/LeadCaptureModal";
import { ReviewModal } from "@/components/ReviewModal";
import { SuggestionModal } from "@/components/SuggestionModal";
import { CommunityVideoModal } from "@/components/CommunityVideoModal";
import { StoryModal } from "@/components/StoryModal";
import { NewVideoPopup } from "@/components/NewVideoPopup";
import { useLeadPopup } from "@/hooks/useLeadPopup";
import { useCommunityPopup } from "@/hooks/useCommunityPopup";
import { useNewVideoPopup } from "@/hooks/useNewVideoPopup";

export default function LandingPage() {
  const leadPopup = useLeadPopup();
  const communityVideoPopup = useCommunityPopup();
  const newVideoPopup = useNewVideoPopup();
  const [reviewOpen, setReviewOpen] = useState(false);
  const [suggestionOpen, setSuggestionOpen] = useState(false);
  const [storyOpen, setStoryOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <Header onEnquire={leadPopup.openManually} />
      <Hero onEnquire={leadPopup.openManually} />
      <VideoGallery sectionId="videos" />
      <Marquee />
      <Manifesto />
      <DonationSection />
      <GoldenShowcase />
      <Reviews onOpenReview={() => setReviewOpen(true)} onOpenSuggestion={() => setSuggestionOpen(true)} />
      <CommunitySection
        key={refreshKey}
        onOpenVideo={communityVideoPopup.openManually}
        onOpenStory={() => setStoryOpen(true)}
      />
      <VideoGallery sectionId="videos-footer" />
      <CareersSection />
      <Footer />
      <WhatsappFab />

      <LeadCaptureModal open={leadPopup.open} onOpenChange={leadPopup.setOpen} />
      <ReviewModal open={reviewOpen} onOpenChange={setReviewOpen} />
      <SuggestionModal open={suggestionOpen} onOpenChange={setSuggestionOpen} />
      <CommunityVideoModal
        open={communityVideoPopup.open}
        onOpenChange={communityVideoPopup.setOpen}
        onUploaded={() => setRefreshKey((k) => k + 1)}
      />
      <StoryModal open={storyOpen} onOpenChange={setStoryOpen} onSubmitted={() => setRefreshKey((k) => k + 1)} />
      <NewVideoPopup open={newVideoPopup.open} onOpenChange={newVideoPopup.setOpen} />
    </div>
  );
}
